import React, { useState, useEffect, useCallback } from "react";
import CommandPalette, { filterItems, getItemIndex, useHandleOpenCommandPalette } from "src/cmdk";
import { CmdkAiContainer } from "./ai/container";
import { CmdkAiTextInput } from "./ai/text-input";

import { useCmdkStore, CMDK_PAGE_IDS } from "./store";

export type PageType = "root" | "create-journey-for-another-company" | "create-journey-about-company" | "create-journey-about-topic" | "create-section-about";

export const CmdkCommands = () => {
  const {page, setPage, open, setOpen, search, setSearch } = useCmdkStore();


  useEffect(() => {
    if (open) {
      setSearch("");
      setPage("root");
    }
  }, [open]);

  const togglePanel = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const closePanel = useCallback(() => {
    setOpen(false);
  }, []);

  useHandleOpenCommandPalette(togglePanel, closePanel);

  const filteredItems = filterItems(
    [
      {
        id: "home",
        items: [
          {
            id: "create-journey-for-another-company",
            children: "Create a Journey for another company",
            icon: (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.60019 4.62002H5.80019M4.60019 7.02H5.80019M10.2002 9.42H11.4002M10.2002 7.02H11.4002M8.20019 13.7997V2.99971C8.20019 2.55788 7.84203 2.19971 7.40019 2.19971H3.0002C2.55837 2.19971 2.2002 2.55788 2.2002 2.99971V12.9997C2.2002 13.4415 2.55837 13.7997 3.0002 13.7997H8.20019ZM8.20019 13.7997H13.0002C13.442 13.7997 13.8002 13.4415 13.8002 12.9997V5.39971C13.8002 4.95788 13.442 4.59971 13.0002 4.59971H8.60019" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            ),
            closeOnSelect: false,
            onClick: () => {
              setPage("create-journey-for-another-company");
            },
          },
          {
            id: "create-journey-about",
            children: "Create a Journey about my company",
            icon: (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.99922 2C2.30298 2 2.54922 2.24624 2.54922 2.55C2.54922 2.79853 2.75069 3 2.99922 3H12.9992C13.2477 3 13.4492 2.79853 13.4492 2.55C13.4492 2.24624 13.6955 2 13.9992 2C14.303 2 14.5492 2.24624 14.5492 2.55C14.5492 3.40604 13.8553 4.1 12.9992 4.1H2.99922C2.14318 4.1 1.44922 3.40604 1.44922 2.55C1.44922 2.24624 1.69546 2 1.99922 2ZM1.44922 6.55C1.44922 5.69396 2.14318 5 2.99922 5H12.9992C13.8553 5 14.5492 5.69396 14.5492 6.55V9.55C14.5492 10.406 13.8553 11.1 12.9992 11.1H2.99922C2.14318 11.1 1.44922 10.406 1.44922 9.55V6.55ZM2.99922 6.1C2.75069 6.1 2.54922 6.30147 2.54922 6.55V9.55C2.54922 9.79853 2.75069 10 2.99922 10H12.9992C13.2477 10 13.4492 9.79853 13.4492 9.55V6.55C13.4492 6.30147 13.2477 6.1 12.9992 6.1H2.99922ZM2.99922 12C2.14318 12 1.44922 12.694 1.44922 13.55C1.44922 13.8538 1.69546 14.1 1.99922 14.1C2.30298 14.1 2.54922 13.8538 2.54922 13.55C2.54922 13.3015 2.75069 13.1 2.99922 13.1H12.9992C13.2477 13.1 13.4492 13.3015 13.4492 13.55C13.4492 13.8538 13.6955 14.1 13.9992 14.1C14.303 14.1 14.5492 13.8538 14.5492 13.55C14.5492 12.694 13.8553 12 12.9992 12H2.99922Z" fill="currentColor" />
              </svg>
            ),
            closeOnSelect: false,
            onClick: () => {
              setPage("create-journey-about-company");
            },
          },
          {
            id: "create-journey-about-topic",
            children: "Create a Journey about a topic",
            icon: (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.99922 2C2.30298 2 2.54922 2.24624 2.54922 2.55C2.54922 2.79853 2.75069 3 2.99922 3H12.9992C13.2477 3 13.4492 2.79853 13.4492 2.55C13.4492 2.24624 13.6955 2 13.9992 2C14.303 2 14.5492 2.24624 14.5492 2.55C14.5492 3.40604 13.8553 4.1 12.9992 4.1H2.99922C2.14318 4.1 1.44922 3.40604 1.44922 2.55C1.44922 2.24624 1.69546 2 1.99922 2ZM1.44922 6.55C1.44922 5.69396 2.14318 5 2.99922 5H12.9992C13.8553 5 14.5492 5.69396 14.5492 6.55V9.55C14.5492 10.406 13.8553 11.1 12.9992 11.1H2.99922C2.14318 11.1 1.44922 10.406 1.44922 9.55V6.55ZM2.99922 6.1C2.75069 6.1 2.54922 6.30147 2.54922 6.55V9.55C2.54922 9.79853 2.75069 10 2.99922 10H12.9992C13.2477 10 13.4492 9.79853 13.4492 9.55V6.55C13.4492 6.30147 13.2477 6.1 12.9992 6.1H2.99922ZM2.99922 12C2.14318 12 1.44922 12.694 1.44922 13.55C1.44922 13.8538 1.69546 14.1 1.99922 14.1C2.30298 14.1 2.54922 13.8538 2.54922 13.55C2.54922 13.3015 2.75069 13.1 2.99922 13.1H12.9992C13.2477 13.1 13.4492 13.3015 13.4492 13.55C13.4492 13.8538 13.6955 14.1 13.9992 14.1C14.303 14.1 14.5492 13.8538 14.5492 13.55C14.5492 12.694 13.8553 12 12.9992 12H2.99922Z" fill="currentColor" />
              </svg>
            ),
            closeOnSelect: false,
            onClick: () => {
              setPage("create-journey-about-topic");
            },
          },
          {
            id: "create-section-about",
            children: "Create a section about",
            icon: (
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 4H3C2.44772 4 2 4.44772 2 5V11C2 11.5523 2.44772 12 3 12H13C13.5523 12 14 11.5523 14 11V5C14 4.44772 13.5523 4 13 4Z" stroke="currentColor" strokeWidth="1.1" />
              </svg>
            ),
            closeOnSelect: false,
            onClick: () => {
              setPage("create-section-about");
            },
          },          
        ],
      },      
    ],
    search
  );

  return (
    <CommandPalette
      onChangeSearch={setSearch}
      onChangeOpen={setOpen}
      search={search}
      isOpen={open}
      page={page}
    >
      <CommandPalette.Page id="root">
        {filteredItems.length ? (
          filteredItems.map((list) => (
            <CommandPalette.List key={list.id} heading={list.heading}>
              {list.items.map(({ id, ...rest }) => (
                <CommandPalette.ListItem
                  key={id}
                  index={getItemIndex(filteredItems, id)}
                  {...rest}
                />
              ))}
            </CommandPalette.List>
          ))
        ) : (
          <CommandPalette.FreeSearchAction />
        )}
      </CommandPalette.Page>
      {CMDK_PAGE_IDS.map((page: PageType) => (
        <CommandPalette.Page key={page} id={page}>
          <CmdkAiContainer page={page} />
        </CommandPalette.Page>
      ))}
      
    </CommandPalette>
  );
};